<template>
  <div class="error">
    <img src="../../assets/images/error/404-icon.png">
    <div class="title">非常抱歉</div>
    <div class="describe">您要查看的页面没有办法找到！</div>
    <div
      class="btn"
      @click="goIndex"
    >返回首页</div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    goIndex() {
      this.$router.replace({
        path: "/"
      });
    }
  }
};
</script>

<style lang='less' scoped>
.error {
  text-align: center;
  background-color: #fff;
  height: 100%;
  padding-top: 200px;
  img {
    width: 269px;
    height: 287px;
  }
  .title {
    font-size: 34px;
    color: #666;
    font-weight: 700;
    padding-top: 20px;
    padding-bottom: 20px;
  }
  .describe {
    color: #999999;
    font-size: 28px;
  }
  .btn {
    padding-left: 38px;
    padding-right: 38px;
    color: #fff;
    height: 58px;
    line-height: 58px;
    font-size: 26px;
    background-color: #1968a8;
    border-radius: 6px;
    display: inline-block;
    margin-top: 50px;
  }
}
</style>
